import axios from 'axios';
import { IResponse } from '~/services/api/types';
import { ICarePlanHospitalization } from './types';

const apiUrl = 'care-plan-hospitalizations';

export const getList = (patientId: number): IResponse<ICarePlanHospitalization[]> =>
  axios({
    method: 'get',
    url: `${apiUrl}/by-patient-id/${patientId}`,
  });

export const create = (
  patientId: number,
  data: ICarePlanHospitalization,
): IResponse<ICarePlanHospitalization> =>
  axios({
    method: 'post',
    url: apiUrl,
    data,
    params: {
      patientId,
    },
  });

export const update = (data: ICarePlanHospitalization): IResponse<ICarePlanHospitalization> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export const remove = (id: number): IResponse<void> =>
  axios({
    method: 'delete',
    url: `${apiUrl}/${id}`,
  });
